import { AdminState } from './types'

export const state: AdminState = {
  adminSettings: null,
  emailAccess: null,
}
